// Explore page constants
export const TAGS = [
  { id: 1, name: "All" },
  { id: 2, name: "Creative" },
  { id: 3, name: "Education" },
  { id: 4, name: "Entertainment" },
  { id: 5, name: "Business" },
  { id: 6, name: "Health" },
  { id: 7, name: "Science" },
  { id: 8, name: "Technology" },
  { id: 9, name: "Sports" },
  { id: 10, name: "Miscellaneous" },
];

export const MENU_OPTIONS = [
  { label: "Most Viewed", value: "most_viewed" },
  { label: "Most Recent", value: "most_recent" },
  { label: "Alphabetical A-Z", value: "alphabetic_asc" },
  { label: "Alphabetical Z-A", value: "alphabetic_desc" },
  { label: "Clones", value: "clones" },
  { label: "Favorites", value: "favorites" },
  { label: "Most Unlocked", value: "most_unlocked" },
];

export const WHEEL_FILTERS = [
  { label: "Clonable", value: "is_clonable" },
  { label: "Favorited Creators", value: "is_static" },
  { label: "Locked", value: "is_locked_clone" },
];

export const CONTENT_TYPE = {
  WHEELS: "Wheels",
  USERS: "Users",
};


export const CONTENT_TYPE_FILTERS = [
  { label: "Wheels", value: CONTENT_TYPE.WHEELS },
  { label: "Users", value: CONTENT_TYPE.USERS },
];
